import { Country } from './config';

const isMultiCountry = (country: Country) => ['ZZ', 'AA'].includes(country);

export default isMultiCountry;
